import type { ReactNode } from 'react';
import './Badge.css';

/** DESIGN.md §10 Badge: New (saffron) · success · count (accent). Never interactive. */
export function Badge({
  variant = 'neutral',
  children,
  className = '',
}: {
  variant?: 'neutral' | 'new' | 'success' | 'count';
  children: ReactNode;
  className?: string;
}) {
  const classes = ['badge', variant !== 'neutral' && `badge--${variant}`, className];
  return <span className={classes.filter(Boolean).join(' ')}>{children}</span>;
}
